module.exports = __webpack_public_path__ + "static/media/bannerImg.478af1e0.svg";